import { useEffect, useRef, useState } from "react";

// Feedback visual do fluxo de finalização no card/dialogs.
// flowBusy = { entregaId, status, phase: "pending" | "success" }
//   pending → botão vira "Enviando…" + demais desabilitados · success → check verde por 1s.
export function useFlowBusy(mountedRef) {
  const [flowBusy, setFlowBusy] = useState(null);
  const successTimerRef = useRef(null);
  useEffect(() => () => { if (successTimerRef.current) clearTimeout(successTimerRef.current); }, []);

  const clearFlowBusy = () => {
    if (successTimerRef.current) { clearTimeout(successTimerRef.current); successTimerRef.current = null; }
    setFlowBusy(null);
  };

  const showFlowSuccess = (entregaId, status, onDone) => {
    setFlowBusy({ entregaId, status, phase: "success" });
    successTimerRef.current = setTimeout(() => {
      if (!mountedRef.current) return;
      setFlowBusy(null);
      successTimerRef.current = null;
      onDone?.();
    }, 1000);
  };

  // Espera 2 frames + 280ms para os Portals do Radix fecharem antes de mexer na lista
  // (reordenar durante a animação causa insertBefore/removeChild no React 18).
  const runAfterDialogClose = (fn) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(() => { if (mountedRef.current) fn(); }, 280);
      });
    });
  };

  return { flowBusy, setFlowBusy, clearFlowBusy, showFlowSuccess, runAfterDialogClose };
}
